export default __webpack_public_path__ + "static/media/Support.9e07a5f8.svg";